import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { BaseColumn, EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import DocumentsListApp, { DocumentsListAppProps } from "../documents/documents";
import { ResourceAppProps } from "./resource";
import React from "react";

export default class RessSozialInGrid extends React.Component<ResourceAppProps, {
    gridData: RessSozial[]
}>{
    private gridOptions = {};
    editableGridRef: EditableGrid;

    constructor(props) {
        super(props);
        this.state = {
            gridData: []
        };
        this.gridOptions = this.props.context.ressSozialInGridOptions;
    }

    componentDidMount() {
        this.bindToSaveSuccessfully();
        this.loadData();
    }

    private bindToSaveSuccessfully = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.loadData();
        });
    }

    private loadData = async () => {
        let url = "Resource/GetGridSozialData?id=" + encodeURIComponent(this.props.entity.Ressnr);
        const result = await HTTPService.get<JsonResultClass<RessSozial[]>>(url)
        if (result.Code == 0) {
            this.props.entity.RessSozialsLoaded = true;
            this.setState({ gridData: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private createNewEntity = (): RessSozial => {
        let entity: RessSozial = {
            IsGuid: kendo.guid(),
            IsNew: true
        }
        return entity;
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let newItem: RessSozial = this.createNewEntity();
                p.actions.add(newItem);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
        }
    }

    render() {
        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit" });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });

        let schema = new Schema();
        schema.Id = "IsGuid";
        schema.fields["IsGuid"] = new field("string");
        return <EditableGrid data={this.state.gridData}
            id="ressSozialInGrid"
            schema={schema}
            gridOptions={this.gridOptions}
            ref={(ref) => this.editableGridRef = ref}
            editable={this.props.entity.RecordRight.CanWrite}
            onDataChanged={() => this.props.context.setEntityDirtyState(true)}
            buttons={buttons}
            onButtonClick={this.handleButtonClick}
            {...this.props} helpEditUrl={this.props.helpUrl}
        />
    }
}

export interface RessSozial {
    Gueltigvon?: Date;
    Gueltigbis?: Date;
    Noreminder?: boolean;
    Email?: string;
    Premonition?: number;
    Ressnr?: string;
    Sozialversicherung?: string;
    Pos?: number;
    Typ?: string;
    Neuantragam?: Date;
    IsGuid?: string;
    LandKF?: string;
    IsNew?: boolean;
}